import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { httpInterceptor } from '../../../API/interceptor.jsx';
import CustomFilterSelect from '../../../shared/customFilterSelect';
import { isSuperadminRole } from '../../../utils/session';
import './style.scss';

function ModalNewUser({ setModalNewUser, typeModal, setEditUser, item, userCreated }) {
    const [isChecked, setIsChecked] = useState(true);
    const [formUser, setFormUser] = useState({
        email: '',
        password: '',
        fullName: '',
        dni: '',
        role: '',
        typeId: '',
        action: ''
    });

    const idTypes = [
        {
            name: 'Cedula',
            id: 'Cedula'
        },
        {
            name: 'Pasaporte',
            id: 'Pasaporte'
        }
    ];

    const roleTypes = [
        {
            name: 'Mediador',
            id: 1
        },
        {
            name: 'Mediador COP',
            id: 'Mediador COP'
        },
        {
            name: 'Mediador NdN',
            id: 3
        },
        {
            name: 'Mediador Control Social',
            id: 6
        },
        {
            name: 'Administrador',
            id: 2
        },
        {
            name: 'Revisor',
            id: 5
        },
        {
            name: 'Logístico',
            id: 8
        }
    ];

    if (isSuperadminRole()) {
        roleTypes.unshift({
            name: 'Superadmin',
            id: 7
        });
    }

    function closeModals() {
        if (setEditUser) setEditUser(false);

        if (setModalNewUser) {
            setModalNewUser(false);
        }
    }

    function addInfo(name, value) {
        setFormUser(prevState => ({ ...prevState, [name]: value }));
    }

    function changeUserState() {
        setIsChecked(prevState => !prevState);
    }

    function submitUser() {
        if (!formUser.role) {
            toast('Rol requerido', {
                type: 'warning'
            });
            return;
        }

        if (!formUser.typeId) {
            toast('Tipo de identificacion requerido', {
                type: 'warning'
            });
            return;
        }

        if (!formUser.dni) {
            toast('Numero de identificacion requerido', {
                type: 'warning'
            });
            return;
        }

        if (!formUser.password) {
            toast('Contrasena requerida', {
                type: 'warning'
            });
            return;
        }

        if (!formUser.fullName) {
            toast('Nombre completo requerido', {
                type: 'warning'
            });
            return;
        }

        const payload = {
            ...formUser,
            action: typeModal,
            active: isChecked
        };

        httpInterceptor
            .post('users', payload)
            .then(res => {
                if (!res) return;

                if (res.success) {
                    toast('El usuario ha sido creado exitosamente', {
                        type: 'success'
                    });
                    userCreated(true);
                } else {
                    toast('Ha ocurrido un problema, por favor intente nuevamente', {
                        type: 'error'
                    });
                }

                closeModals();
            })
            .catch(error => {
                const errorCode =
                    error?.response?.data?.code || error?.response?.data?.message?.code;
                const errorMessage = String(
                    error?.response?.data?.errorMessage ||
                        error?.response?.data?.message ||
                        ''
                );

                if (errorCode === '23505') {
                    toast('El usuario ya existe', {
                        type: 'error'
                    });
                    return;
                }

                if (error === 'MIN LENGTH') {
                    toast('La contrasena debe tener minimo 8 caracteres', {
                        type: 'error'
                    });
                    return;
                }

                if (errorMessage.startsWith('ROLE_NOT_FOUND:')) {
                    const roleName = errorMessage.replace('ROLE_NOT_FOUND:', '').trim();
                    toast(`El rol "${roleName}" no existe en la base de datos`, {
                        type: 'error'
                    });
                    return;
                }

                if (errorMessage === 'ROLE_REQUIRED') {
                    toast('Rol requerido', {
                        type: 'warning'
                    });
                    return;
                }

                toast('No se pudo crear el usuario. Verifica los datos e intenta nuevamente', {
                    type: 'error'
                });
            });
    }

    useEffect(() => {
        setIsChecked(item?.active ?? true);
        setFormUser({
            email: item?.email ?? '',
            password: item?.password ?? '',
            fullName: item?.full_name ?? '',
            dni: item?.document ?? '',
            role: item?.role_id ?? item?.role?.name ?? '',
            typeId: item?.document_type ?? '',
            action: ''
        });
    }, [item]);

    return (
        <section className='main-createUser-container'>
            <p className='title'>
                {typeModal === 'create' ? 'CREAR NUEVO USUARIO' : 'EDITAR USUARIO'}{' '}
            </p>
            <section className='create-container'>
                {typeModal === 'edit' ? (
                    <div className='toggle-state-container'>
                        <p className='user-state'>{isChecked ? 'Activo' : 'No activo'}</p>

                        <label className='switch'>
                            <input onChange={changeUserState} type='checkbox' checked={isChecked} />
                            <span className='slider round'></span>
                        </label>
                    </div>
                ) : null}
                <div></div>
                <div className='typeRol-container'>
                    <CustomFilterSelect
                        edit={item?.role?.name}
                        optionsList={roleTypes}
                        keyName='role'
                        addInfo={addInfo}
                        placeholder='Rol'
                    />
                </div>
                <label className='label' htmlFor=''>
                    <input
                        placeholder='Nombre completo'
                        type='text'
                        name='fullName'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        value={formUser.fullName}
                        className='input-form'
                    />
                </label>
                <div className='typeId-container'>
                    <CustomFilterSelect
                        edit={item?.document_type}
                        optionsList={idTypes}
                        addInfo={addInfo}
                        keyName='typeId'
                        placeholder='Tipo de identificacion'
                    />
                </div>
                <label className='label' htmlFor=''>
                    <input
                        placeholder='Numero de identificacion'
                        type='number'
                        name='dni'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        value={formUser.dni}
                        className='input-form'
                        readOnly={typeModal === 'edit'}
                    />
                </label>

                <label className='email-container' htmlFor=''>
                    <input
                        placeholder='Correo electronico'
                        type='text'
                        name='email'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        value={formUser.email}
                        className='input-form'
                    />
                </label>
                <label className='label' htmlFor=''>
                    <input
                        placeholder='Contrasena'
                        value={formUser.password}
                        type='text'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        name='password'
                        className='input-form'
                    />
                </label>
                <div className='buttons-container'>
                    <button
                        type='button'
                        onClick={submitUser}
                        className='blue-site-button create'
                    >
                        {typeModal === 'create' ? 'CREAR' : 'ACTUALIZAR'}
                    </button>
                    <button
                        type='button'
                        onClick={closeModals}
                        className='button-white-border-blue'
                    >
                        CANCELAR
                    </button>
                </div>
            </section>
        </section>
    );
}

export default ModalNewUser;
